module.exports = __webpack_public_path__ + "img/logo_login.3bb726e1.png";